import { createUseStyles } from 'react-jss'
import { ThemeDefinition } from '../../../../data/types'
import MediaQueries from '../../../../styles/MediaQueries'

const useStyles = createUseStyles((theme: ThemeDefinition) => ({
  overlay: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  playContainer: {
    cursor: 'pointer',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&:hover $playIcon': {
      fill: theme.primaryColor.light
    },
    '&:active $playIcon': {
      fill: theme.primaryColor.dark
    }
  },
  playShade: {
    width: '17.407%',
    '&:before': {
      display: 'block',
      content: '""',
      paddingTop: '100%'
    },
    borderRadius: '50%',
    backgroundColor: 'rgba(0, 0, 0, 0.453125)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  playIcon: {
    width: '40%',
    height: 'auto',
    fill: theme.primaryColor.default
  },
  [MediaQueries.Tablet]: {
    playShade: {
      width: '65px'
    }
  },
  [MediaQueries.LaptopLarge]: {
    playShade: {
      width: '80px'
    }
  }
}))

export default useStyles
